(function() {
  'use strict';

  /**
   * Initialize ZIP input with IMask and basic validation
   */
  function initZipInput() {
    var input = document.getElementById('appointment-zip-code-search');
    var button = document.querySelector('#zip-code-fallback .zip-code-button-search');

    if (!input || !button) return;

    // Set correct input attributes
    input.setAttribute('type', 'text');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '5');
    input.setAttribute('pattern', '\\d{5}');
    input.autocomplete = 'postal-code';

    // Apply IMask for 5 digits
    if (window.IMask) {
      IMask(input, { mask: '00000' });
    }

    function isFiveDigitZip(value) {
      return /^\d{5}$/.test(value);
    }

    function handleSubmit() {
      var zip = (input.value || '').trim();
      if (!isFiveDigitZip(zip)) {
        input.focus();
        return;
      }

      try {
        sessionStorage.setItem('zipcode', zip);
      } catch (e) {
        // ignore
      }

      if (typeof window.appointmentScheduling?.onZipCodeSearch === 'function') {
        window.appointmentScheduling.onZipCodeSearch(zip);
      } else {
        // Fallback: dispatch a custom event
        var evt = new CustomEvent('zip:search', { detail: { zip: zip } });
        window.dispatchEvent(evt);
      }
    }

    button.addEventListener('click', function(e) {
      e.preventDefault();
      handleSubmit();
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSubmit();
      }
    });
  }

  // Secondary input may be dynamically rendered later
  document.addEventListener('focusin', function(e) {
    var tgt = e.target;
    if (tgt && tgt.id === 'secondary-zip-code-search') {
      tgt.setAttribute('type', 'text');
      tgt.setAttribute('inputmode', 'numeric');
      tgt.setAttribute('maxlength', '5');
      tgt.setAttribute('pattern', '\\d{5}');
      if (window.IMask && !tgt._imask) {
        IMask(tgt, { mask: '00000' });
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZipInput);
  } else {
    initZipInput();
  }
})();
